import { Link } from "react-router-dom";
import { Linkedin, Mail, MapPin } from "lucide-react";
import BrandMark from "@/components/BrandMark";

const LINKEDIN_URL = "https://www.linkedin.com/company/deploydnow";

export default function SiteFooter() {
  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 border-t border-zinc-200 bg-white/60 px-6 pb-10 pt-16 sm:px-10 lg:px-16"
    >
      <div className="mx-auto grid w-full max-w-6xl grid-cols-2 gap-10 sm:grid-cols-4">
        {/* Brand column */}
        <div className="col-span-2 sm:col-span-1">
          <p className="font-display text-2xl font-extrabold text-zinc-900">
            <BrandMark size="inline" />
          </p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-zinc-600">
            The only repository of verified AI use cases in production &mdash;
            curated for your industry.
          </p>
          <div className="mt-5 flex items-center gap-3">
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              className="inline-flex items-center gap-2 border border-zinc-300 bg-white px-3 py-2 font-mono-tech text-[10px] uppercase tracking-[0.22em] text-zinc-700 hover:border-emerald-500 hover:text-emerald-700"
            >
              <Linkedin className="h-3.5 w-3.5" /> LinkedIn
            </a>
          </div>
        </div>

        {/* Product */}
        <Col title="Product">
          <FLink to="/feed">Industry feed</FLink>
          <FLink to="/dashboard">Contribute a case</FLink>
          <FLink to="/case-study/zenskar-100ms">Latest use case</FLink>
        </Col>

        {/* Company */}
        <Col title="Company">
          <FLink to="/about">About</FLink>
          <FExternal href="mailto:hello@deploydnow.com">Contact</FExternal>
          <FExternal href={LINKEDIN_URL}>LinkedIn</FExternal>
        </Col>

        {/* Legal */}
        <Col title="Legal">
          <FLink to="/terms">Terms of Use</FLink>
          <FLink to="/privacy">Privacy Policy</FLink>
          <FLink to="/cookies">Cookie Notice</FLink>
        </Col>
      </div>

      <div className="mx-auto mt-14 flex w-full max-w-6xl flex-col items-start justify-between gap-3 border-t border-zinc-200 pt-6 font-mono-tech text-[10px] uppercase tracking-[0.24em] text-zinc-500 sm:flex-row sm:items-center">
        <span>
          © {new Date().getFullYear()} <BrandMark size="inline" />, Inc. All rights reserved.
        </span>
        <span className="inline-flex items-center gap-4">
          <span className="inline-flex items-center gap-1">
            <MapPin className="h-3 w-3 text-emerald-600" /> San Francisco · CA
          </span>
          <a href="mailto:hello@deploydnow.com" className="inline-flex items-center gap-1 hover:text-emerald-700">
            <Mail className="h-3 w-3 text-emerald-600" /> hello@deploydnow.com
          </a>
        </span>
      </div>
    </footer>
  );
}

const Col = ({ title, children }) => (
  <div>
    <p className="font-mono-tech text-[10px] uppercase tracking-[0.28em] text-zinc-500">
      {title}
    </p>
    <ul className="mt-4 space-y-2.5">{children}</ul>
  </div>
);

const FLink = ({ to, children }) => (
  <li>
    <Link
      to={to}
      className="font-display text-sm text-zinc-800 no-underline hover:text-emerald-700"
    >
      {children}
    </Link>
  </li>
);

const FExternal = ({ href, children }) => (
  <li>
    <a
      href={href}
      target={href.startsWith("http") ? "_blank" : undefined}
      rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
      className="font-display text-sm text-zinc-800 no-underline hover:text-emerald-700"
    >
      {children}
    </a>
  </li>
);
